<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3h10v14H3z M13 3v14M5 6h6M5 9h6M5 12h4"
      stroke="currentColor"
      stroke-width="1.4"
      fill="none"
      stroke-linejoin="round"
    />
  </svg>
</template>
